import styled from 'styled-components';

import { Button } from '@xing-com/button';
import { Divider as BaseDivider } from '@xing-com/divider';
import { mediaTopBarHidden } from '@xing-com/layout-tokens';
import {
  xdlColorButtonStrong,
  xdlColorButtonStrongHover,
  xdlColorTextInvert,
  xdlColorTextOnDark,
  xdlPaletteGrayPlain11,
  spaceM,
  spaceS,
} from '@xing-com/tokens';

export const Container = styled.div`
  margin: 0 auto;
  width: 100%;
  max-width: 800px;

  @media ${mediaTopBarHidden} {
    max-width: 648px;
  }
`;

export const Form = styled.form`
  display: grid;
  grid-template-columns: auto;
  grid-template-areas:
    'key'
    'div'
    'loc';
  padding-left: 20px;
  padding-right: 20px;

  @media ${mediaTopBarHidden} {
    padding-left: 0;
    padding-right: 0;
  }

  /* We hide the border on hover when the other input is focused
  to avoid having two borders visually */
  &:has(input:focus-visible) {
    textarea:hover {
      border-bottom-color: transparent;
    }
  }

  &:has(textarea:focus-visible) {
    input:hover {
      border-top-color: transparent;
    }
  }
`;

export const Divider = styled(BaseDivider)`
  grid-area: div;
`;

export const LocationFieldsWrapper = styled.div`
  grid-area: loc;
  display: flex;
  position: relative;
`;

export const SubmitButton = styled(Button)`
  grid-area: but;
  position: absolute;
  right: ${spaceM};
  top: ${spaceS};
  color: ${xdlColorTextInvert};
  flex-shrink: 0;

  &::after {
    background-color: ${xdlColorButtonStrong};
  }

  &:hover::after {
    background-color: ${xdlColorButtonStrongHover};
  }

  &:active {
    color: ${xdlColorTextOnDark};

    &::after {
      background-color: ${xdlPaletteGrayPlain11};
    }
  }
`;
